const { getElements } = window.BAO.Utils

class MediaOverride {
  constructor () {
    this.listeners = new window.BAO.Listeners()
  }

  init () {
    this.mediaOverrideContainer = document.querySelector(
      '[data-media-override-el="container"]',
    )
    this.productCards = getElements('[data-media-override-el="card"]')
    this.mediaOverride = this.mediaOverrideContainer?.dataset.mediaOverride
    this.mediaHoverOverride =
      this.mediaOverrideContainer?.dataset.mediaHoverOverride

    if (
      this.mediaOverrideContainer &&
      this.productCards.length > 0 &&
      (this.mediaOverride || this.mediaHoverOverride)
    ) {
      this.setupCollectionPage()
      return
    }

    if (this.isProductPage()) {
      this.setupProductPage()
    }
  }

  isProductPage () {
    return (
      document.querySelector('[template-product], [data-product-form]') !== null
    )
  }

  async setupCollectionPage () {
    try {
      const attributes = {
        'Media Override Selection': this.mediaOverride || '',
        'Media Hover Override Selection': this.mediaHoverOverride || '',
      }

      await window.BAO.Cart.updateCartAttributes(attributes)
    } catch (error) {
      console.error('MediaOverride: Failed to set cart attributes:', error)
    }

    this.listeners.add(window, 'beforeunload', () => {
      this.clearCartAttributesSync()
    })

    this.productCards.forEach((card) => {
      const fauxLink = card.querySelector('.prd-Card_FauxLink')
      if (fauxLink) {
        this.listeners.add(fauxLink, 'click', () => {
          // Mark that we're navigating to a product
          sessionStorage.setItem('navigating_to_product', 'true')
        })
      }

      const allCardLinks = card.querySelectorAll('a[href*="/products/"]')
      allCardLinks.forEach((link) => {
        this.listeners.add(link, 'click', () => {
          sessionStorage.setItem('navigating_to_product', 'true')
        })
      })
    })
  }

  setupProductPage () {
    setTimeout(() => {
      this.clearCartAttributes()
      sessionStorage.removeItem('navigating_to_product')
    }, 100)
  }

  clearCartAttributesSync () {
    const navigatingToProduct =
      sessionStorage.getItem('navigating_to_product') === 'true'

    if (!navigatingToProduct) {
      if (navigator.sendBeacon) {
        const formData = new FormData()
        formData.append('attributes[Media Override Selection]', '')
        formData.append('attributes[Media Hover Override Selection]', '')

        navigator.sendBeacon('/cart/update.js', formData)
      }
    }
  }

  async clearCartAttributes () {
    try {
      const attributes = {
        'Media Override Selection': '',
        'Media Hover Override Selection': '',
      }

      await window.BAO.Cart.updateCartAttributes(attributes)
    } catch (error) {
      console.error('MediaOverride: Failed to clear cart attributes:', error)
    }
  }

  destroy () {
    this.listeners.removeAll()
  }
}

let mediaOverrideInstance

document.addEventListener('DOMContentLoaded', () => {
  if (mediaOverrideInstance) {
    mediaOverrideInstance.destroy()
  }

  mediaOverrideInstance = new MediaOverride()
  mediaOverrideInstance.init()
})

window.addEventListener('beforeunload', () => {
  if (mediaOverrideInstance) {
    mediaOverrideInstance.destroy()
  }
})
